var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountExecutives = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 17.5c.287-1.078 1.297-1.875 2.5-1.875s2.213.797 2.5 1.875M15 15.625a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 16.25h-6.25a.625.625 0 0 1-.625-.625V5a.625.625 0 0 1 .625-.625h4.166c.136 0 .267.044.375.125l2.168 1.625c.108.081.24.125.375.125h6.666a.625.625 0 0 1 .625.625v2.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountExecutives);
export default ForwardRef;